import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class ModuleFinalGradesStateModel extends SubentityStateModel {
    filters = {
        list: [],
    };
    totalCount: number;
    pageSize: number;
    pageNumber: number;
    sortBy: string;
    sortOrder: SortDirection;

    constructor() {
        super();

        this.searchTerm = sessionStorage.getItem('finalGradesSearchTerm');
        this.sortBy = sessionStorage.getItem('moduleFinalGradesSortBy');
        this.sortOrder = sessionStorage.getItem('moduleFinalGradesSortOrder') as SortDirection;
    }
}
